import React from 'react'
import { FormattedMessage } from 'react-intl'

import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { TaskModal } from './TaskModal'

export type AddTaskModalProps = {
  visible: boolean
  onAdd: (description: string) => Promise<void>
  onClose: () => void
}

export const AddTaskModal: React.FC<AddTaskModalProps> = ({ visible, onAdd, onClose }) => (
  <TaskModal
    visible={visible}
    onClose={onClose}
    title={<FormattedMessage defaultMessage='Add task' description='Add task modal title' />}
    primaryButtonText={<FormattedMessage defaultMessage='Add' description='Add task modal primary button' />}
    onPrimaryPress={onAdd}
    testID={tID('AddTaskModal')}
  />
)
